import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../../constants';

type LogoProps = {
  className: string;
};

const Logo: React.FC<LogoProps> = ({ className = '' }) => {
  const navigate = useNavigate();
  return (
    <div
      className={`flex justify-center cursor-pointer ${className}`}
      onClick={() => navigate(ROUTES.HOME)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          navigate(ROUTES.HOME);
        }
      }}
    >
      <img
        src="/trademark-logo.png"
        alt="Wisedoc Logo"
        className="h-8 w-auto"
        style={{ maxWidth: '200px' }}
      />
    </div>
  );
};

export default Logo;
